/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconNumber1 = createReactComponent("number-1", "IconNumber1", [
  ["path", { d: "M13 20v-16l-5 5", key: "svg-0" }]
]);

export { IconNumber1 as default };
//# sourceMappingURL=IconNumber1.js.map
